import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Application, RudyApplicationModel } from 'models/Application';
import { Business } from 'models/Business';

export interface InitialState {
  inheritanceTypeFilter: ('Division' | 'Business' | 'BusinessWithDivisionOverride')[];
  customerSearch?: string;
  cachedBusinessList?: Business[];
  cachedDivisionApplicationList: { [key: string]: RudyApplicationModel[] };
  isTriggerLoading: boolean;
  isCustomersTriggerLoading: boolean;
  isDivAppsTriggerLoading: boolean;
  cachedInternalApplications?: Application[];
  navSearchValue: string;
}

export const initialState: InitialState = {
  inheritanceTypeFilter: ['Business', 'Division', 'BusinessWithDivisionOverride'],
  customerSearch: undefined,
  cachedBusinessList: undefined,
  cachedDivisionApplicationList: {},
  cachedInternalApplications: undefined,
  isTriggerLoading: false,
  isCustomersTriggerLoading: false,
  isDivAppsTriggerLoading: false,
  navSearchValue: ''
};

export const businessListSlice = createSlice({
  name: 'businessList',
  initialState,
  reducers: {
    setInheritanceTypeFilter: (state, { payload }: PayloadAction<InitialState['inheritanceTypeFilter']>) => {
      if (JSON.stringify(state.inheritanceTypeFilter) !== JSON.stringify(payload)) {
        state.inheritanceTypeFilter = payload;
      }
    },
    setCustomerSearch: (state, { payload }: PayloadAction<InitialState['customerSearch']>) => {
      if (state.customerSearch !== payload) {
        state.customerSearch = payload;
      }
    },
    setCachedBusinessList: (state, { payload }: PayloadAction<InitialState['cachedBusinessList']>) => {
      if (JSON.stringify(state.cachedBusinessList) !== JSON.stringify(payload)) {
        state.cachedBusinessList = payload;
      }
    },
    setCachedInternalApplicationList: (state, { payload }: PayloadAction<InitialState['cachedInternalApplications']>) => {
      if (JSON.stringify(state.cachedInternalApplications) !== JSON.stringify(payload)) {
        state.cachedInternalApplications = payload;
      }
    },
    setNavSearchValue: (state, { payload }: PayloadAction<InitialState['navSearchValue']>) => {
      if (state.navSearchValue !== payload) {
        state.navSearchValue = payload;
      }
    },
    setIsTriggerLoading: (state, { payload }: PayloadAction<InitialState['isTriggerLoading']>) => {
      if (state.isTriggerLoading !== payload) {
        state.isTriggerLoading = payload;
      }
    },
    setIsCustomersTriggerLoading: (state, { payload }: PayloadAction<InitialState['isCustomersTriggerLoading']>) => {
      if (state.isCustomersTriggerLoading !== payload) {
        state.isCustomersTriggerLoading = payload;
      }
    },
    setIsDivAppsTriggerLoading: (state, { payload }: PayloadAction<InitialState['isDivAppsTriggerLoading']>) => {
      if (state.isDivAppsTriggerLoading !== payload) {
        state.isDivAppsTriggerLoading = payload;
      }
    },
    putApplicationsForDivisions: (state, { payload }: PayloadAction<{ key: string; value: RudyApplicationModel[] }>) => {
      const { key, value } = payload;
      if (JSON.stringify(state.cachedDivisionApplicationList[key]) !== JSON.stringify(value)) {
        state.cachedDivisionApplicationList[key] = value;
      }
    }
  }
});

export const {
  setInheritanceTypeFilter,
  setCustomerSearch,
  setCachedBusinessList,
  putApplicationsForDivisions,
  setIsTriggerLoading,
  setCachedInternalApplicationList,
  setIsCustomersTriggerLoading,
  setIsDivAppsTriggerLoading,
  setNavSearchValue
} = businessListSlice.actions;
